<template>
  <div
    class="flex flex-col min-w-0 w-full max-w-full overflow-hidden shadow-[0_0px_21px_-4px_rgba(10,10,10,0.3)]"
    :style="containerStyle"
  >
    <component
      :is="renderItem.element"
      v-for="(renderItem, index) in props.items"
      :key="index"
      v-bind="renderItem.attrs"
      class="appearance-none flex items-center justify-center min-w-0 w-full border-0 bg-transparent p-0 no-underline focus:no-underline"
      :class="{
        'cursor-pointer': renderItem.interactive,
      }"
      :style="getItemStyle(renderItem.source)"
      @click="onItemClick(renderItem, $event)"
    >
      <img
        v-if="renderItem.source.leftImage"
        :src="renderItem.source.leftImage"
        alt=""
        draggable="false"
        class="min-w-0 max-w-[40%] object-contain"
        :style="{
          maxHeight: toPixels(renderItem.source.leftImageMaxHeight),
        }"
      />
      <div
        v-if="renderItem.source.text"
        class="whitespace-pre-wrap break-words min-w-0 shrink"
        :style="{
          paddingLeft: toPixels(renderItem.source.textPaddingLeft),
          paddingRight: toPixels(renderItem.source.textPaddingRight),
        }"
      >
        {{ renderItem.source.text }}
      </div>
      <img
        v-if="renderItem.source.rightImage"
        :src="renderItem.source.rightImage"
        alt=""
        draggable="false"
        class="min-w-0 max-w-[40%] object-contain"
        :style="{
          maxHeight: toPixels(renderItem.source.rightImageMaxHeight),
        }"
      />
    </component>
  </div>
</template>

<script setup lang="ts">
import type {
  FloatingBannerFormData,
  FloatingBannerItem,
  FloatingBannerRenderItem,
} from './types'

interface PropsInterface {
  formData: FloatingBannerFormData
  items: FloatingBannerRenderItem[]
}

const props = defineProps<PropsInterface>()
const emit = defineEmits<{
  'item-click': [item: FloatingBannerItem, event: MouseEvent]
}>()

const containerStyle = computed(() => {
  return {
    backgroundColor: props.formData.backgroundColor,
    borderColor: props.formData.borderColor,
    borderStyle: 'solid',
    borderWidth: toPixels(props.formData.borderWidth),
    borderRadius: toPixels(props.formData.borderRadius),
    paddingLeft: toPixels(props.formData.paddingLeft),
    paddingRight: toPixels(props.formData.paddingRight),
    paddingTop: toPixels(props.formData.paddingVertical),
    paddingBottom: toPixels(props.formData.paddingVertical),
    gap: toPixels(props.formData.itemsGap),
  }
})

function toPixels(value: number): string {
  return `${value}px`
}

function getItemStyle(item: FloatingBannerItem) {
  return {
    color: item.textColor,
    fontSize: toPixels(item.textSize),
    fontWeight: item.fontWeight,
  }
}

function onItemClick(renderItem: FloatingBannerRenderItem, event: Event) {
  emit('item-click', renderItem.source, event as MouseEvent)
}
</script>
